export default "__VITE_ASSET__B30GnxRP__"